/**
 * Optimized FontAwesome icon configuration
 * Only imports the icons actually used in the package
 */

import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Regular icons
import { faShareFromSquare } from '@fortawesome/pro-regular-svg-icons';

// Solid icons
import {
  faEllipsis as faEllipsisSolid,
  faTag as faTagSolid,
  faBug,
  faBugSlash,
} from '@fortawesome/pro-solid-svg-icons';

// Light icons
import { faClone as faCloneLight } from '@fortawesome/pro-light-svg-icons';

const regularIcons: IconDefinition[] = [faShareFromSquare];

const solidIcons: IconDefinition[] = [faEllipsisSolid, faTagSolid, faBug, faBugSlash];

const lightIcons: IconDefinition[] = [faCloneLight];

// Add all icon arrays to the library
library.add(...regularIcons);
library.add(...solidIcons);
library.add(...lightIcons);
